import Icon from '@forwardflow/ui/Icons'
import { Avatar } from 'antd'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
export const RecentConversations = ({
   recentConversations,
}: {
   recentConversations: any
}) => {
   return (
      <>
         <div className="bg-[#3B3C42] rounded text-[14px] font-medium">
            <div className="flex items-center justify-between px-8 py-5 border-b border-white/20">
               <span>Recent Conversations</span>
               <div className="text-[#AB7AE0] items-center gap-x-2 hidden">
                  <p>View Active conversations</p>
                  <Icon
                     name="ArrowRightSmall"
                     className="stroke-[#AB7AE0] mt-1"
                  />
               </div>
            </div>
            <div
               className="flex flex-col gap-2 p-4 overflow-y-auto max-h-[260px]"
               data-testid="recent-conversations-scrollable-container"
            >
               {recentConversations && recentConversations.length > 0 ? (
                  recentConversations.map((item: any, index: number) => (
                     <div
                        key={index}
                        className="flex items-center px-4 py-3 bg-[#2B2B30] rounded-lg"
                     >
                        <Avatar>
                           {item?.firstName?.charAt(0)}
                           {item?.lastName?.charAt(0)}
                        </Avatar>
                        <div className="flex flex-col flex-1 px-4 gap-y-2">
                           <p className="text-[14px] font-medium">
                              {item?.firstName}&nbsp;
                              {item?.lastName}
                           </p>
                           <p className="text-white/70 text-[12px]">
                              {item?.lastConversation?.content}
                           </p>
                        </div>
                        <div className="flexc gap-x-2">
                           {item?.lastConversation?.conversationType ===
                           'message' ? (
                              <Icon name="Chat" className="stroke-[#818181]" />
                           ) : item?.lastConversation?.conversationType ===
                             'call' ? (
                              <Icon name="Call" className="stroke-[#818181]" />
                           ) : item?.lastConversation?.conversationType ===
                             'appointment' ? (
                              <Icon
                                 name="Calendar"
                                 className="stroke-[#818181]"
                              />
                           ) : item?.lastConversation?.conversationType ===
                             'note' ? (
                              <Icon
                                 name="FileText"
                                 className="stroke-[#818181]"
                              />
                           ) : (
                              <Icon
                                 name="MessageSquare"
                                 className="stroke-[#818181]"
                              />
                           )}

                           <span>{item?.lastConversation?.date}</span>
                        </div>
                     </div>
                  ))
               ) : (
                  <div className="flex items-center justify-center py-8">
                     <p className="text-white/70 text-[14px]">
                        No recent conversations available
                     </p>
                  </div>
               )}
            </div>
         </div>
      </>
   )
}
